// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__QClwY","page":"Loader_page__j42A2","loader":"Loader_loader__DwtSp","rotating":"Loader_rotating__ZEny3","md":"Loader_md__d0rCR","lg":"Loader_lg__9CCwO"};